import React, { useEffect, useState, Fragment, useMemo } from 'react';
import Moment from 'moment';
import axios from 'axios';
import styled from 'styled-components';
import PaperContainer from '../../components/PaperContainer';
import { Badge, Button, Spinner, Modal, Form, OverlayTrigger, InputGroup, FormControl, Tabs, Tab } from 'react-bootstrap';
import { fetchCeresUsers, db, updateUser, adminCreateUser } from '../../services/firebase';
import * as R from 'ramda';
import { TIERS } from '../../types/tiers';
import { Edit, Trash } from 'react-feather';
import { toast } from 'react-toastify';
import DataTable, { createTheme } from 'react-data-table-component';
import type { IDataTableStyles } from 'react-data-table-component';
import ReactTooltip from 'react-tooltip';
import { API_BASE_URL, API_AUTH_HEADERS } from '../../util/api.util';
import { doc, updateDoc, deleteDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

createTheme('ceresDark', {
  text: {
    primary: '#e2e8f0',
    secondary: '#94a3b8',
  },
  background: {
    default: 'transparent',
  },
  context: {
    background: 'rgba(52, 211, 153, 0.18)',
    text: '#f8fafc',
  },
  divider: {
    default: 'rgba(148, 163, 184, 0.18)',
  },
  action: {
    button: 'rgba(0,0,0,.54)',
    hover: 'rgba(0,0,0,.08)',
    disabled: 'rgba(0,0,0,.12)',
  },
});

const correctiveTrackerTableStyles: IDataTableStyles = {
  table: {
    style: {
      backgroundColor: 'transparent',
    },
  },
  tableWrapper: {
    style: {
      display: 'table',
      width: '100%',
    },
  },
  headRow: {
    style: {
      backgroundColor: 'rgba(15, 23, 42, 0.9)',
      borderBottom: '1px solid rgba(148, 163, 184, 0.25)',
      minHeight: '60px',
    },
  },
  headCells: {
    style: {
      color: '#f8fafc',
      fontFamily: 'var(--sans, "DM Sans", -apple-system, sans-serif)',
      fontSize: '15px',
      fontWeight: 600,
      letterSpacing: '0.01em',
      justifyContent: 'center',
      textAlign: 'center',
      borderRight: '1px solid rgba(148, 163, 184, 0.25)',
      paddingLeft: '10px',
      paddingRight: '10px',
    },
  },
  rows: {
    style: {
      backgroundColor: 'rgba(15, 23, 42, 0.45)',
      borderBottom: '1px solid rgba(148, 163, 184, 0.2)',
      minHeight: '48px',
    },
    highlightOnHoverStyle: {
      backgroundColor: 'rgba(15, 23, 42, 0.62)',
      outline: 'none',
    },
  },
  cells: {
    style: {
      color: '#dbe3ef',
      fontFamily: 'var(--sans, "DM Sans", -apple-system, sans-serif)',
      fontSize: '14px',
      lineHeight: 1.35,
      paddingTop: '10px',
      paddingBottom: '10px',
      borderRight: '1px solid rgba(148, 163, 184, 0.2)',
      alignItems: 'flex-start',
    },
  },
};

const NotificationPageContainer = styled<any>(PaperContainer)`
  display: flex;
  flex: 1;
  flex-direction: column;
  background: rgba(10, 10, 12, 0.72);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 1rem 1rem 0.75rem;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(10px);
  margin: 1rem;

  .user-panel-table {
    overflow: auto;
    height: 67vh;
    background: transparent;

    .rdt_Table {
      background: transparent;
    }

    .rdt_TableHeadRow {
      background: rgba(15, 23, 42, 0.9) !important;
    }

    .rdt_TableCol,
    .rdt_TableCol * {
      color: #f8fafc !important;
    }

    .rdt_TableRow {
      background: rgba(15, 23, 42, 0.45) !important;
      border-bottom: 1px solid rgba(148, 163, 184, 0.2) !important;
    }

    .rdt_TableRow:hover {
      background: rgba(15, 23, 42, 0.62) !important;
    }

    .rdt_TableCell {
      color: #dbe3ef !important;
      background: rgba(15, 23, 42, 0.45) !important;
      border-right: 1px solid rgba(148, 163, 184, 0.2);
    }

    .rdt_TableHead {
      border-bottom: 1px solid rgba(148, 163, 184, 0.25);
    }

    .rdt_TableHeadRow {
      background: rgba(15, 23, 42, 0.9);
      border-bottom-color: rgba(148, 163, 184, 0.25);
      min-height: 52px;
    }

    .rdt_TableCol,
    .rdt_TableCol * {
      text-align: left;
      color: #f8fafc;
      font-family: 'DM Sans', -apple-system, sans-serif !important;
      font-size: 11px !important;
      font-weight: 500 !important;
      letter-spacing: 0.04em !important;
      text-transform: uppercase !important;
    }

    .rdt_TableRow {
      background: rgba(15, 23, 42, 0.45);
      border-bottom: 1px solid rgba(148, 163, 184, 0.2);
      min-height: 48px;
    }

    .rdt_TableRow:hover {
      background: rgba(15, 23, 42, 0.62);
    }

    .rdt_TableCell {
      color: #dbe3ef;
      font-family: 'DM Sans', -apple-system, sans-serif !important;
      font-size: 13px !important;
      font-weight: 500;
      letter-spacing: 0.01em !important;
      line-height: 1.35;
      padding-top: 10px;
      padding-bottom: 10px;
    }

    .rdt_TableCell .table-pill {
      font-family: 'DM Sans', -apple-system, sans-serif !important;
    }
  }

  .enviroagent-table {
    background: transparent;

    .rdt_Table {
      background: transparent;
    }

    .rdt_TableHeadRow {
      background: rgba(15, 23, 42, 0.9) !important;
    }

    .rdt_TableCol,
    .rdt_TableCol * {
      color: #f8fafc !important;
    }

    .rdt_TableRow {
      background: rgba(15, 23, 42, 0.45) !important;
      border-bottom: 1px solid rgba(148, 163, 184, 0.2) !important;
    }

    .rdt_TableRow:hover {
      background: rgba(15, 23, 42, 0.62) !important;
    }

    .rdt_TableCell {
      color: #dbe3ef !important;
      background: rgba(15, 23, 42, 0.45) !important;
      border-right: 1px solid rgba(148, 163, 184, 0.2);
    }

    .rdt_TableHead {
      border-bottom: 1px solid rgba(148, 163, 184, 0.25);
    }

    .rdt_TableHeadRow {
      background: rgba(15, 23, 42, 0.9);
      border-bottom-color: rgba(148, 163, 184, 0.25);
      min-height: 52px;
    }

    .rdt_TableCol,
    .rdt_TableCol * {
      text-align: left;
      color: #f8fafc;
      font-family: var(--sans, 'DM Sans', -apple-system, sans-serif) !important;
      font-size: 11px !important;
      font-weight: 500 !important;
      letter-spacing: 0.04em !important;
      text-transform: uppercase !important;
    }

    .rdt_TableRow {
      background: rgba(15, 23, 42, 0.45);
      border-bottom: 1px solid rgba(148, 163, 184, 0.2);
      min-height: 48px;
    }

    .rdt_TableRow:hover {
      background: rgba(15, 23, 42, 0.62);
    }

    .rdt_TableCell {
      color: #dbe3ef;
      font-family: var(--sans, 'DM Sans', -apple-system, sans-serif) !important;
      font-size: 13px !important;
      font-weight: 400 !important;
      line-height: 1.35;
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }

  .nav-tabs {
    width: fit-content;
    border: none;
    border-bottom: none;
    border-radius: 12px;
    background: #111315;
    padding: 4px;
    margin: 0 1.2em 1rem;
    gap: 2px;
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .nav-tabs .nav-item {
    margin-bottom: 0;
  }

  .nav-tabs .nav-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #94a3b8;
    border: none !important;
    border-radius: 8px;
    padding: 9px 16px;
    font-family: var(--sans, 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif);
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0.01em;
    line-height: 1;
    background: transparent;
    transition: color 0.15s ease, background 0.15s ease;
    -webkit-font-smoothing: antialiased;
  }

  .nav-tabs .nav-link:hover {
    color: #e2e8f0;
    background: rgba(255, 255, 255, 0.04);
    border: none !important;
  }

  .nav-tabs .nav-link:focus {
    outline: none;
    box-shadow: none;
    border: none !important;
  }

  .nav-tabs .nav-link::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
    flex-shrink: 0;
  }

  .nav-tabs .nav-link.active {
    color: #ffffff;
    font-weight: 600;
    background: #202327;
    border: none !important;
    box-shadow: none;
  }

  .nav-tabs .nav-link.active:hover,
  .nav-tabs .nav-link.active:focus {
    color: #ffffff;
    background: #25292e;
    border: none !important;
  }

  .nav-tabs .nav-item:nth-child(1) .nav-link::before {
    background: #7dd3fc;
  }

  .nav-tabs .nav-item:nth-child(2) .nav-link::before {
    background: #2dd4bf;
  }
`;

const UserPanelHeader = styled.h3`
 font-size:  36px;
  font-weight: 400;
  line-height: 1.08;
  letter-spacing: -0.01em;
  color: #fafafa;
  text-align: left;
  font-family: 'Instrument Serif', Georgia, serif;

  em {
    font-style: italic;
    color: #7ef0c2;
    font-family: 'Instrument Serif', Georgia, serif;
  }
`;

const TierBadge = styled(Badge)`
  font-weight: 600;
  letter-spacing: 0.02em;
`;

const TablePill = styled.span.attrs({ className: 'table-pill' })<{ tone?: 'teal' | 'green' | 'blue' | 'amber' | 'red' | 'slate' }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 84px;
  padding: 0.28rem 0.62rem;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  border: 1px solid transparent;

  ${(props) =>
    props.tone === 'teal' &&
    `
    color: #22d3ee;
    background: rgba(8, 47, 73, 0.45);
    border-color: rgba(34, 211, 238, 0.25);
  `}

  ${(props) =>
    props.tone === 'green' &&
    `
    color: #34d399;
    background: rgba(6, 47, 34, 0.45);
    border-color: rgba(52, 211, 153, 0.25);
  `}

  ${(props) =>
    props.tone === 'blue' &&
    `
    color: #60a5fa;
    background: rgba(8, 47, 73, 0.45);
    border-color: rgba(96, 165, 250, 0.25);
  `}

  ${(props) =>
    props.tone === 'amber' &&
    `
    color: #facc15;
    background: rgba(69, 56, 11, 0.45);
    border-color: rgba(250, 204, 21, 0.24);
  `}

  ${(props) =>
    props.tone === 'red' &&
    `
    color: #fb7185;
    background: rgba(76, 5, 25, 0.45);
    border-color: rgba(251, 113, 133, 0.22);
  `}

  ${(props) =>
    props.tone === 'slate' &&
    `
    color: #cbd5e1;
    background: rgba(30, 41, 59, 0.5);
    border-color: rgba(148, 163, 184, 0.2);
  `}
`;

const TinyStatusBadge = styled.span<{ tone?: 'green' | 'blue' | 'amber' | 'red' | 'teal' }>`
  display: inline-block;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 4px;
  font-family: var(--sans, 'DM Sans', -apple-system, sans-serif);

  ${(props) =>
    props.tone === 'green' &&
    `
    background: rgba(52,211,153,.14);
    color: #34d399;
  `}

  ${(props) =>
    props.tone === 'blue' &&
    `
    background: rgba(96,165,250,.1);
    color: #60a5fa;
  `}

  ${(props) =>
    props.tone === 'amber' &&
    `
    background: rgba(251,191,36,.08);
    color: #fbbf24;
  `}

  ${(props) =>
    props.tone === 'red' &&
    `
    background: rgba(248,113,113,.08);
    color: #f87171;
  `}

  ${(props) =>
    props.tone === 'teal' &&
    `
    background: rgba(45,212,191,.08);
    color: #2dd4bf;
  `}
`;

const ActionButton = styled(Button)`
  svg {
    width: 20px;
    height: 20px;
  }
  margin-right: 5px;
  border-radius: 10px;
`;

const AddUserButton = styled(Button)`
  margin-left: 1rem;
  background: #3aefb8;
  border: none;
  color: #000 !important;
  border-radius: 12px;
  padding: 0.45rem 0.9rem;
  font-size: 14px;
  font-weight: 700;
  font-family: 'DM Sans', -apple-system, sans-serif;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  box-shadow: 0 8px 20px rgba(52, 211, 153, 0.28);
  transition: background 0.15s ease, transform 0.12s ease;

  &::before {
    content: '+';
    color: #000;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1;
  }

  &:hover,
  &:focus,
  &:active {
    background: #63f4ca !important;
    color: #000 !important;
    border: none !important;
    box-shadow: 0 12px 28px rgba(94, 234, 212, 0.32) !important;
    transform: translateY(-1px);
  }
`;

const SpinnerContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;

const renderTierBadge = (tier: TIERS, BadgeComp = TierBadge) => {
  return R.cond<any, any>([
    [
      R.equals(TIERS.DAYPASS),
      () => <TablePill tone="amber">DAYPASS</TablePill>,
    ],
    [
      R.equals(TIERS.PLATINUM),
      () => <TablePill tone="blue">PLATINUM</TablePill>,
    ],
    [
      R.equals(TIERS.BASIC),
      () => <TablePill tone="teal">BASIC</TablePill>,
    ],
    [
      R.equals(TIERS.FREE),
      () => <TablePill tone="green">FREE</TablePill>,
    ],
    [
      R.T,
      () => <TablePill tone="slate">N/A</TablePill>,
    ],
  ])(tier);
};

const renderLoadingSpinner = () => (
  <SpinnerContainer>
    <Spinner variant="primary" animation="border" />
  </SpinnerContainer>
);

const EditUserPanelBody = styled(Modal.Body)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const EditUserPanelItem = styled.div`
  margin-bottom: 6px;
`;

const EditUserModal = styled(Modal)`
  .modal-dialog {
    max-width: 520px;
    width: 90%;
  }

  .modal-content {
    background: rgba(7, 10, 13, 0.95);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 20px;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
    padding: 32px;
    max-height: 80vh;
    overflow-y: auto;
  }

  .modal-header {
    border-bottom: 0;
    padding: 0 0 20px;
  }

  .modal-title {
    color: #f8fafc;
    font-size: 20px;
    font-weight: 600;
    line-height: 1.2;
    margin-bottom: 0;
    font-family: var(--sans, 'DM Sans', -apple-system, sans-serif);
  }

  .close {
    color: #546170;
    float: right;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 20px;
    padding: 4px;
    text-shadow: none;
    opacity: 1;
  }

  .close:hover {
    color: #ecf0f5;
  }

  .modal-body {
    padding: 0;
  }

  .form-group {
    margin-bottom: 14px;
  }

  .form-label {
    display: block;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    color: #546170;
    margin-bottom: 6px;
    font-family: var(--sans, 'DM Sans', -apple-system, sans-serif);
  }

  .form-control {
    width: 100%;
    padding: 10px 14px;
    min-height: 46px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 8px;
    font-family: var(--sans, 'DM Sans', -apple-system, sans-serif);
    font-size: 14px;
    color: #ecf0f5;
    outline: none;
    transition: border-color 0.15s;
  }

  .form-control:focus {
    box-shadow: none;
    border-color: rgba(52, 211, 153, 0.35);
    background: rgba(255, 255, 255, 0.04);
    color: #ecf0f5;
  }

  .form-control[as='select'],
  .form-control[type='select'],
  select.form-control {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    padding-right: 38px;
    cursor: pointer;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 14px;
  }

  select.form-control option {
    background: rgba(6, 10, 15, 0.98);
    color: #ecf0f5;
  }

  .modal-footer {
    border-top: 0;
    padding: 16px 0 0;
    display: flex;
    gap: 10px;
  }
`;

const EditUserCloseButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 10px;
  font-family: var(--sans);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.06);
  color: #ecf0f5;

  &:hover,
  &:focus,
  &:active {
    background: rgba(255, 255, 255, 0.1) !important;
    border-color: rgba(255, 255, 255, 0.1) !important;
    color: #ecf0f5 !important;
  }
`;

const EditUserSaveButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 10px;
  font-family: var(--sans);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  border: none;
  background: #3aefb8;
  color: var(--bg) !important;

  &:hover,
  &:focus,
  &:active {
    background: #63f4ca !important;
    color: var(--bg) !important;
    border: none !important;
    transform: scale(1.02);
  }

  &:disabled {
    opacity: 0.7;
  }
`;
const EditUserPanel: React.FC<any> = (props: any) => {
  const user: any = props.user;
  const [currentTier, setCurrentTier] = useState<string>('');
  const [currentStatus, setCurrentStatus] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);

  const updateUserInfo = () => {
    axios.post(
      API_BASE_URL + '/api/updateUserInfo',
      // 'http://localhost:5000/ceres-platform-test/us-central1/api/updateUserInfo',
      user,
      {
        headers: API_AUTH_HEADERS,
      }
    );
  };

  useEffect(() => {
    setCurrentTier((user && user.tier) || '');
  }, [user]);
  return (
    <EditUserModal dialogClassName="ceres--subscription-list" show={props.show || false} onHide={props.onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit User</Modal.Title>
      </Modal.Header>
      <EditUserPanelBody>
        {!user ? (
          <></>
        ) : (
          <Form>
            <EditUserPanelItem>
              <Form.Group controlId="formBasicEmail">
                <Form.Label>Tier</Form.Label>
                <Form.Control
                  disabled={isLoading}
                  as="select"
                  value={currentTier}
                  onChange={(e: any) => setCurrentTier(e.target.value)}
                >
                  {R.map(
                    (tier: TIERS) => (
                      <option key={tier}>{tier}</option>
                    ),
                    Object.keys(TIERS).filter((c: any) => c !== TIERS.SUPER_ADMIN) as TIERS[]
                  )}
                </Form.Control>
              </Form.Group>
              <Form.Group controlId="formBasicEmail">
                <Form.Label>Email Verified Status</Form.Label>
                <Form.Control
                  disabled={isLoading}
                  as="select"
                  value={currentStatus}
                  onChange={(e: any) => setCurrentStatus(e.target.value)}
                >
                  <option>Select Verified Status</option>
                  <option value="Verified">Verified</option>
                  <option value="Unverified">Unverified</option>
                </Form.Control>
              </Form.Group>
            </EditUserPanelItem>
          </Form>
        )}
      </EditUserPanelBody>
      <Modal.Footer>
        <EditUserCloseButton variant="secondary" onClick={props.onHide} disabled={isLoading}>
          Close
        </EditUserCloseButton>
        <EditUserSaveButton
          variant="primary"
          onClick={() => {
            setIsLoading(true);
            const userRef = doc(db, 'users', user.uid);
            updateDoc(userRef, {
              tier: currentTier,
            })
              .then(() => {
                toast.success(`Saved user information successfully`);
                props.onSaveComplete({
                  ...user,
                  ...{ tier: currentTier },
                });
              })
              .catch(() => {
                toast.error(`Error while saving user information`);
              })
              .finally(() => {
                updateUserInfo();
                setIsLoading(false);
                if (currentStatus) {
                  updateUser({
                    uid: user.uid,
                    emailVerified: currentStatus === 'Verified' ? true : false,
                  }).then(() => {
                    setCurrentStatus('');
                    props.onSaveComplete({
                      ...user,
                      ...{ tier: currentTier, emailVerified: currentStatus === 'Verified' ? true : false },
                    });
                  });
                }
              });
          }}
        >
          {isLoading ? <Spinner animation="border" size="sm" className="cmn-spinner-var-bg" /> : 'Save changes'}
        </EditUserSaveButton>
      </Modal.Footer>
    </EditUserModal>
  );
};

const TotalUsersDiv = styled.h5`
  margin: 0 1.2em 1em;
  color: #dbe3ef;
  font-size: 0.95rem;
  font-weight: 600;
`;

const SearchContainer = styled(InputGroup)`
  margin: 0 1.2em 1em;
  max-width: 400px;

  .form-control {
    background: rgba(15, 23, 42, 0.62) !important;
    border: 1px solid rgba(148, 163, 184, 0.25) !important;
    color: #e2e8f0 !important;
  }

  .form-control::placeholder {
    color: #94a3b8;
  }

  .form-control:focus {
    box-shadow: 0 0 0 2px rgba(52, 211, 153, 0.16);
    border-color: rgba(52, 211, 153, 0.42) !important;
    background: rgba(15, 23, 42, 0.75) !important;
    color: #f8fafc !important;
  }

  /* User List search only: Chrome autofill / paste must not use light blue fill */
  .form-control:-internal-autofill-selected,
  .form-control:-webkit-autofill,
  .form-control:-webkit-autofill:hover,
  .form-control:-webkit-autofill:focus,
  .form-control:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px rgba(15, 23, 42, 0.92) inset !important;
    box-shadow: 0 0 0 1000px rgba(15, 23, 42, 0.92) inset !important;
    -webkit-text-fill-color: #e2e8f0 !important;
    caret-color: #e2e8f0;
    border: 1px solid rgba(52, 211, 153, 0.42) !important;
    transition: background-color 99999s ease-out 0s;
  }
`;

const AddUserModal = styled(Modal)`
  .modal-dialog {
    max-width: 520px;
    width: 90%;
  }

  .modal-backdrop.show {
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(8px);
  }

  .modal-content {
    background: rgba(7, 10, 13, 0.95);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 20px;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
    padding: 32px;
    max-height: 80vh;
    overflow-y: auto;
  }

  .modal-header {
    border-bottom: 0;
    padding: 0 0 20px;
  }

  .modal-title {
    color: #f8fafc;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 0;
    line-height: 1.2;
    letter-spacing: 0;
    font-family: var(--sans, 'DM Sans', -apple-system, sans-serif);
  }

  .close {
    color: #546170;
    float: right;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 20px;
    padding: 4px;
    text-shadow: none;
    opacity: 1;
  }

  .close:hover {
    color: #ecf0f5;
  }

  .modal-body {
    padding: 0;
  }

  .form-group {
    margin-bottom: 0.95rem;
  }

  .form-label {
    color: #546170;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    margin-bottom: 6px;
    font-family: var(--sans, 'DM Sans', -apple-system, sans-serif);
  }

  .form-control {
    width: 100%;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.06);
    color: #ecf0f5;
    border-radius: 8px;
    min-height: 46px;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0;
    font-family: var(--sans, 'DM Sans', -apple-system, sans-serif);
    padding: 10px 14px;
    outline: none;
    transition: border-color 0.15s;
  }

  .form-control::placeholder {
    color: #546170;
    font-weight: 400;
  }

  .form-control:focus {
    box-shadow: none;
    border-color: rgba(52, 211, 153, 0.35);
    background: rgba(255, 255, 255, 0.04);
    color: #ecf0f5;
  }

  .modal-footer {
    border-top: 0;
    padding: 16px 0 0;
  }
`;

const AddUserPrimaryButton = styled(Button)`
  width: 100%;
  justify-content: center;
  margin-top: 8px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 10px;
  font-family: var(--sans);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  background: #3aefb8;
  color: #000 !important;
  border: none;

  &:hover,
  &:focus,
  &:active {
    background: #63f4ca !important;
    color: #000 !important;
    border: none !important;
    box-shadow: none !important;
  }

  &:disabled {
    background: #3aefb8 !important;
    color: #000 !important;
    opacity: 0.65;
  }

  .spinner-border {
    color: #000 !important;
    border-right-color: transparent !important;
  }
`;

const AddUserCancelButton = styled(Button)`
  display: none;
`;


const TableContentWrapper = styled.div`
  color: #e2e8f0;
`;

const DarkPagination = ({
  rowsPerPage,
  rowCount,
  currentPage,
  onChangePage,
  onChangeRowsPerPage,
}: any) => {
  const [open, setOpen] = useState(false);
  const rowsOptions = [10, 15, 20, 25, 30];
  const totalPages = Math.max(1, Math.ceil((rowCount || 0) / (rowsPerPage || 10)));
  const start = rowCount === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
  const end = Math.min(currentPage * rowsPerPage, rowCount || 0);

  return (
    <div className="users-dark-pagination">
      <span className="rows-label">Rows per page:</span>
      <div className="rows-dropdown">
        <button className="rows-trigger" onClick={() => setOpen(!open)} type="button">
          <span>{rowsPerPage}</span>
          <span>▼</span>
        </button>
        {open && (
          <div className="rows-menu">
            {rowsOptions.map((opt) => (
              <button
                key={opt}
                type="button"
                className={`rows-option ${rowsPerPage === opt ? 'active' : ''}`}
                onClick={() => {
                  onChangeRowsPerPage(opt, currentPage);
                  setOpen(false);
                }}
              >
                {opt}
              </button>
            ))}
          </div>
        )}
      </div>
      <span>{start}-{end} of {rowCount || 0}</span>
      <button
        type="button"
        className="nav-btn"
        onClick={() => onChangePage(currentPage - 1)}
        disabled={currentPage <= 1}
      >
        ‹
      </button>
      <button
        type="button"
        className="nav-btn"
        onClick={() => onChangePage(currentPage + 1)}
        disabled={currentPage >= totalPages}
      >
        ›
      </button>
    </div>
  );
};

const ClickableCount = styled.span`
  color: #34d399;
  cursor: pointer;
  text-decoration: underline;
  &:hover {
    color: #5eead4;
  }
`;

const ENVIRO_AGENT_API_BASE = process.env.REACT_APP_ENVIROCHAT_API_ENDPOINT;

// EnviroAgent Usage Component
const EnviroAgentUsage: React.FC = () => {
  const [usageData, setUsageData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedUserDetails, setSelectedUserDetails] = useState<any>(null);
  const [detailedPermits, setDetailedPermits] = useState<any[]>([]);
  const [loadingDetails, setLoadingDetails] = useState(false);

  const fetchUsageData = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${ENVIRO_AGENT_API_BASE}/get_pbr_user_stats`);
      setUsageData(response.data);
    } catch (error: any) {
      toast.error('Failed to load EnviroAgent usage data');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchUserPermitDetails = async (userId: string) => {
    setLoadingDetails(true);
    try {
      const response = await axios.get(`${ENVIRO_AGENT_API_BASE}/get_pbr_records?user_id=${userId}`);
      setDetailedPermits(response.data);
    } catch (error: any) {
      toast.error('Failed to load permit details');
      setDetailedPermits([]);
    } finally {
      setLoadingDetails(false);
    }
  };

  const markPermitCharged = async (userId: string, chatId: string) => {
    try {
      const response = await axios.post(`${ENVIRO_AGENT_API_BASE}/mark_permit_charged`, {
        user_id: userId,
        chat_id: chatId,
      });

      if (response.data.success) {
        toast.success('Permit marked as charged successfully');
        // Refresh the permit details
        fetchUserPermitDetails(userId);
        // Refresh the usage data
        fetchUsageData();
      }
    } catch (error: any) {
      toast.error('Failed to mark permit as charged');
    }
  };

  const handlePBRClick = (user: any) => {
    setSelectedUserDetails(user);
    setShowDetailsModal(true);
    fetchUserPermitDetails(user.user_id);
  };

  useEffect(() => {
    fetchUsageData();
  }, []);

  const usageColumns = [
    {
      name: 'User ID',
      selector: 'user_id',
      sortable: true,
      width: '200px',
    },
    {
      name: 'Email',
      selector: 'email',
      sortable: true,
      cell: (row: any) => <span>{row.email || 'N/A'}</span>,
    },
    {
      name: 'Display Name',
      selector: 'display_name',
      sortable: true,
      cell: (row: any) => <span>{row.display_name || 'N/A'}</span>,
    },
    {
      name: 'Tier',
      selector: 'tier',
      cell: (row: any) => {
        return (
          <TinyStatusBadge
            tone={
              row.tier === 'FREE'
                ? 'green'
                : row.tier === 'PLATINUM'
                ? 'blue'
                : row.tier === 'BASIC'
                ? 'teal'
                : row.tier === 'DAYPASS'
                ? 'amber'
                : 'red'
            }
          >
            {row.tier || 'N/A'}
          </TinyStatusBadge>
        );
      },
    },
    {
      name: 'PBR Limits',
      selector: 'completed_pbr',
      sortable: true,
      cell: (row: any) => (
        <ClickableCount onClick={() => handlePBRClick(row)}>
          {row.completed_pbr}/{row.total_pbr}
          {row.unbilled_pbr > 0 && ` (${row.unbilled_pbr} unbilled)`}
        </ClickableCount>
      ),
    },
    {
      name: 'Last Updated',
      selector: 'last_updated_at',
      sortable: true,
      cell: (row: any) => <span>{Moment(row.last_updated_at).format('MMM DD, YYYY HH:mm')}</span>,
    },
  ];

  const permitDetailsColumns = [
    {
      name: 'Chat ID',
      selector: 'chat_id',
      sortable: true,
      width: '100px',
    },
    {
      name: 'Model',
      selector: 'model',
      cell: (row: any) => <span>{row.model || 'N/A'}</span>,
      width: '100px',
    },
    {
      name: 'Created Date',
      selector: (row: any) => row.permit_metadata?.created_at,
      sortable: true,
      cell: (row: any) => (
        <span>
          {row.permit_metadata?.created_at
            ? Moment(row.permit_metadata.created_at).format('MMM DD, YYYY HH:mm')
            : 'N/A'}
        </span>
      ),
    },
    {
      name: 'Completed Date',
      selector: (row: any) => row.permit_metadata?.completed_at,
      sortable: true,
      cell: (row: any) => (
        <span>
          {row.permit_metadata?.completed_at
            ? Moment(row.permit_metadata.completed_at).format('MMM DD, YYYY HH:mm')
            : 'N/A'}
        </span>
      ),
    },
    {
      name: 'Permit Type',
      selector: (row: any) => row.permit_metadata?.permit_type,
      cell: (row: any) => <span>{row.permit_metadata?.permit_type || 'N/A'}</span>,
    },
    {
      name: 'Status',
      selector: (row: any) => row.permit_metadata?.status,
      cell: (row: any) => (
        <TinyStatusBadge tone={row.permit_metadata?.status === 'completed' ? 'green' : 'amber'}>
          {row.permit_metadata?.status || 'in_progress'}
        </TinyStatusBadge>
      ),
    },
    {
      name: 'Charged',
      selector: (row: any) => row.permit_metadata?.charged,
      cell: (row: any) => (
        <TinyStatusBadge tone={row.permit_metadata?.charged ? 'green' : 'red'}>
          {row.permit_metadata?.charged ? 'Yes' : 'No'}
        </TinyStatusBadge>
      ),
    },
    {
      name: 'Actions',
      cell: (row: any) => (
        <Button
          size="sm"
          variant={row.permit_metadata?.charged ? 'secondary' : 'primary'}
          disabled={row.permit_metadata?.charged}
          onClick={() => markPermitCharged(selectedUserDetails.user_id, row.chat_id)}
        >
          {row.permit_metadata?.charged ? 'Charged' : 'Mark Charged'}
        </Button>
      ),
    },
  ];

  return (
    <>
      {isLoading && renderLoadingSpinner()}
      {!isLoading && <TotalUsersDiv>Total Users: {usageData.length || 0}</TotalUsersDiv>}
      {!isLoading && (
        <TableContentWrapper>
          <DataTable
            className="enviroagent-table"
            columns={usageColumns}
            data={usageData}
            pagination
            paginationComponent={DarkPagination}
            theme="ceresDark"
            customStyles={correctiveTrackerTableStyles}
          />
        </TableContentWrapper>
      )}

      {/* Permit Details Modal */}
      <Modal
        show={showDetailsModal}
        onHide={() => setShowDetailsModal(false)}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Permit Details - {selectedUserDetails?.email || selectedUserDetails?.user_id}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedUserDetails && (
            <div className="cmn-details-block">
              <p><strong>User ID:</strong> {selectedUserDetails.user_id}</p>
              <p><strong>Email:</strong> {selectedUserDetails.email || 'N/A'}</p>
              <p><strong>Display Name:</strong> {selectedUserDetails.display_name || 'N/A'}</p>
              <p><strong>Tier:</strong> {selectedUserDetails.tier}</p>
              <p><strong>Completed PBR:</strong> {selectedUserDetails.completed_pbr}</p>
              <p><strong>Total PBR:</strong> {selectedUserDetails.total_pbr}</p>
              <p><strong>Unbilled PBR:</strong> {selectedUserDetails.unbilled_pbr}</p>
              <p><strong>Last Updated:</strong> {Moment(selectedUserDetails.last_updated_at).format('MMM DD, YYYY HH:mm')}</p>
            </div>
          )}
          {loadingDetails ? (
            <SpinnerContainer>
              <Spinner variant="primary" animation="border" />
            </SpinnerContainer>
          ) : (
            <DataTable
              className="enviroagent-table"
              columns={permitDetailsColumns}
              data={detailedPermits}
              pagination
              paginationComponent={DarkPagination}
              noDataComponent="No permit details available"
              theme="ceresDark"
              customStyles={correctiveTrackerTableStyles}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDetailsModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const UsersPanel: React.FC = () => {
  const [userList, setUserList] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentEditState, setEditState] = useState<any>(null);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeTab, setActiveTab] = useState<string>('users');
  const [newUserData, setNewUserData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    displayName: '',
  });


  const getUserCorporateDomain = async (userEmail: string): Promise<any> => {
    const authInstance = getAuth();
    const currentUser = authInstance.currentUser;
    const headers = { ...API_AUTH_HEADERS };
    if (currentUser) {
      const token = await currentUser.getIdToken();
      headers['Authorization'] = `Bearer ${token}`;
    }

    return await axios.post(
      API_BASE_URL + '/api/getUserCorporateDomain',
      { email: userEmail },
      { headers }
    );
  };


  const handleAddUser = async () => {
    if (newUserData.password !== newUserData.confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }
    if (!newUserData.email || !newUserData.password) {
      toast.error('Email and password are required');
      return;
    }
    if (newUserData.password.length < 6) {
      toast.error('Password must be at least 6 characters long');
      return;
    }

    setIsLoading(true);

    try {
      const getTierInfo: any = await getUserCorporateDomain(newUserData.email);
      const membershipTier =
      getTierInfo && getTierInfo.data.length > 0 && getTierInfo.data[0].membership_tier
          ? getTierInfo.data[0].membership_tier.toUpperCase() as TIERS
          : TIERS.FREE;

      const result = await adminCreateUser({
        email: newUserData.email,
        password: newUserData.password,
        displayName: newUserData.displayName,
        tier: membershipTier
      });

      if (result.data) {
        toast.success(`User ${newUserData.email} created successfully.`);
        setShowAddUserModal(false);
        setNewUserData({
          email: '',
          password: '',
          confirmPassword: '',
          displayName: '',
        });
        await loadCeresUsers();
      }
    } catch (error: any) {
      if (error.code === 'functions/permission-denied') {
        toast.error('You do not have permission to create users.');
      } else if (error.code === 'functions/already-exists') {
        toast.error('This email address is already in use.');
      } else if (error.code === 'functions/invalid-argument') {
        toast.error(error.message || 'Invalid input provided.');
      } else {
        toast.error(error.message || 'Failed to create user.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const filteredUsers = useMemo(() => {
    if (!searchTerm) {
      return userList;
    }

    // tslint:disable-next-line:no-console
    console.log('searchTerm=>', searchTerm);

    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    return userList.filter(user =>
      (user.email && user.email.toLowerCase().includes(lowerCaseSearchTerm)) ||
      (user.uid && user.uid.toLowerCase().includes(lowerCaseSearchTerm)) ||
      (user.displayName && user.displayName.toLowerCase().includes(lowerCaseSearchTerm))
    );
  }, [userList, searchTerm]);

  const columns = [
    {
      name: 'UID',
      selector: 'uid',
    },
    {
      name: 'Email',
      selector: 'email',
      sortable: true,
    },
    {
      name: 'Tier',
      selector: 'tier',
      cell: (row: any) => <Fragment>{renderTierBadge(row.tier)}</Fragment>,
    },
    {
      name: 'Display Name',
      selector: 'displayName',
      sortable: true,
    },
    {
      name: 'Last SignIn Time',
      selector: (row: any) => Moment(row.lastSignInTime).format(),
      cell: (row: any) => <span>{row.lastSignInTime}</span>,
      sortable: true,
    },
    {
      name: 'Email Verified Status',
      selector: (row: any) => Moment(row.lastSignInTime).format(),
      cell: (row: any) => (
        <TablePill tone={row.emailVerified ? 'green' : 'red'}>
          {row.emailVerified ? 'Verified' : 'Unverified'}
        </TablePill>
      ),
      sortable: true,
    },
    {
      name: 'Actions',
      selector: 'year',
      cell: (row: any) => (
        <Fragment>
           <OverlayTrigger
                overlay={<ReactTooltip place="bottom" effect="solid" />}
                >
              <ActionButton variant="secondary" onClick={() => setEditState(row)} data-tip="Edit User">
                <Edit />
              </ActionButton>
            </OverlayTrigger>
            <OverlayTrigger
                overlay={<ReactTooltip place="bottom" effect="solid" />}
                >
              <ActionButton
                variant="danger"
                data-tip="Delete User"
                onClick={() => {
                  const userRef = doc(db, 'users', row.uid);
                  deleteDoc(userRef)
                    .then(() => {
                      setUserList(
                        R.filter((user: any) => {
                          return user.uid !== row.uid;
                        }, userList)
                      );
                      toast.success(`Deleted user successfully: ${row.email}`);
                    })
                    .catch(() => toast.error(`Oops, something went wrong, while deleting the user`));
                }}
                >
                <Trash />
              </ActionButton>
            </OverlayTrigger>
        </Fragment>
      ),
    },
  ];
  const Datatable = () => (
    <DataTable
      className="user-panel-table"
      columns={columns}
      data={filteredUsers}
      pagination
      paginationComponent={DarkPagination}
      theme="ceresDark"
      customStyles={correctiveTrackerTableStyles}
    />
  );
  const loadCeresUsers = async () => {
    try {
      setIsLoading(true);
      let allUsers: any[] = [];
      let pageToken: string | undefined;
      let hasMorePages = true;

      // Fetch all pages of users
      while (hasMorePages) {
        const result = await fetchCeresUsers({
          size: 1000, // Increase page size to reduce number of requests
          pageToken,
        });
        // Explicitly type the data property of the result
        const data = result.data as { records?: any[], nextPageToken?: string };
        if (data && data.records) {
          allUsers = [...allUsers, ...data.records];
        }

        // Check if there are more pages
        pageToken = data.nextPageToken;
        hasMorePages = !!pageToken;
      }

      setUserList(allUsers);
    } catch (error: any) {
      // Updated error code checking for httpsCallable
      if (error.code === 'functions/permission-denied') {
        toast.error('You do not have permission to view users.');
      } else {
        toast.error('Failed to load users');
      }
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    loadCeresUsers();
    return;
  }, []);

  return (
    <NotificationPageContainer>
      <UserPanelHeader>
        Manage <em>CERES</em> Users
        {activeTab === 'users' && (
          <AddUserButton
            onClick={() => setShowAddUserModal(true)}
          >
            Add User
          </AddUserButton>
        )}
      </UserPanelHeader>

      <AddUserModal show={showAddUserModal} onHide={() => setShowAddUserModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add New User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={(e) => { e.preventDefault(); handleAddUser(); }}>
            <Form.Group controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                value={newUserData.email}
                onChange={(e) => setNewUserData({...newUserData, email: e.target.value})}
                placeholder="Enter email"
                required
              />
            </Form.Group>
            <Form.Group controlId="formPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                value={newUserData.password}
                onChange={(e) => setNewUserData({...newUserData, password: e.target.value})}
                placeholder="Enter password"
                required
                minLength={6}
              />
            </Form.Group>
            <Form.Group controlId="formConfirmPassword">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type="password"
                value={newUserData.confirmPassword}
                onChange={(e) => setNewUserData({...newUserData, confirmPassword: e.target.value})}
                placeholder="Confirm password"
                required
                minLength={6}
              />
            </Form.Group>
            <Form.Group controlId="formDisplayName">
              <Form.Label>Display Name (Optional)</Form.Label>
              <Form.Control
                type="text"
                value={newUserData.displayName}
                onChange={(e) => setNewUserData({...newUserData, displayName: e.target.value})}
                placeholder="Enter display name (optional)"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <AddUserCancelButton variant="secondary" onClick={() => setShowAddUserModal(false)}>
            Cancel
          </AddUserCancelButton>
          <AddUserPrimaryButton variant="primary" type="submit" onClick={handleAddUser} disabled={isLoading}>
            {isLoading ? <Spinner animation="border" size="sm" /> : 'Create User'}
          </AddUserPrimaryButton>
        </Modal.Footer>
      </AddUserModal>

      <EditUserPanel
        show={!!currentEditState}
        user={currentEditState}
        onSaveComplete={(updatedUserInformation: any) => {
          const uid = updatedUserInformation.uid;
          setUserList(
            R.map((user: any) => {
              if (user.uid === uid) {
                return updatedUserInformation;
              }
              return user;
            }, userList)
          );
          setEditState(null);
        }}
        onHide={() => setEditState(null)}
      />

      <Tabs
        activeKey={activeTab}
        onSelect={(key) => setActiveTab(key || 'users')}
        id="admin-panel-tabs"
        className="mb-3"
      >
        <Tab eventKey="users" title="User List">
          {isLoading && renderLoadingSpinner()}
          {!isLoading && <TotalUsersDiv>Total Users: {filteredUsers.length || 0}</TotalUsersDiv>}
          {!isLoading && (
            <TableContentWrapper>
              <SearchContainer>
                <FormControl
                  placeholder="Search by Email, UID, or Display Name..."
                  aria-label="Search Users"
                  value={searchTerm}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchTerm(e.target.value)}
                />
              </SearchContainer>
              <Datatable />
            </TableContentWrapper>
          )}
        </Tab>
        <Tab eventKey="enviroagent" title="EnviroAgent Usage">
          <EnviroAgentUsage />
        </Tab>
      </Tabs>
    </NotificationPageContainer>
  );
};

export default UsersPanel;
